import PropTypes from 'prop-types'
import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect, useState } from 'react'
import { faFileLines } from '@fortawesome/free-regular-svg-icons'
import { useNavigate } from 'react-router-dom'
import NormalInfo from './NormalInfo'
import Benefits from './sections/Benefits'
import BillingData from './sections/BillingData'
import CardDelivery from './sections/CardDelivery'
import BabyRoomInfo from './sections/BabyRoomInfo'
import ActionButton from '../../EmployeeDetails/components/ActionButton'
import { REPOSITORY } from '../../../api/repository/Repository'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'

function ShowMore({ clicked, handleClick }) {
  const { texts } = useLabels()
  return (
    <HStack _hover={{ cursor: 'pointer' }} onClick={handleClick}>
      <Text textDecorationLine="underline" variant="caption1">
        {`${
          clicked ? texts.close : texts.watch
        } información completa de la empresa`}
      </Text>
      <FontAwesomeIcon icon={clicked ? faChevronUp : faChevronDown} />
    </HStack>
  )
}

ShowMore.propTypes = {
  clicked: PropTypes.bool,
  handleClick: PropTypes.func,
}
export default function CompanyDetails() {
  const { texts } = useLabels()
  const navigate = useNavigate()
  const [showMore, setShowMore] = useState()
  const [companyDetails, setCompanyDetails] = useState(null)

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const getCompanyDetails = useCallback(async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.company
      .companyDetails()
      .then((res) => {
        setCompanyDetails(res.data)
        handleCLoseLoading()
      })
      .catch(() => {
        handleCLoseLoading()
      })
  }, [handleCLoseLoading, handleOpenLoading])

  const handleShowMore = () => {
    setShowMore(true)
  }

  const handleShowLess = () => {
    setShowMore(false)
  }

  const goToManagementReports = useCallback(() => {
    navigate('reports')
  }, [navigate])

  useEffect(() => {
    getCompanyDetails()
  }, [getCompanyDetails])

  return (
    <VStack spacing="35px" px="8%" alignItems="flex-start" mb="60px" w="100%">
      <VStack spacing="35px" alignItems="flex-start" maxW="894px">
        <NormalInfo showMore={showMore} data={companyDetails} />
        {showMore && (
          <>
            <Benefits data={companyDetails} />
            <BillingData data={companyDetails} />
            <CardDelivery data={companyDetails} />
            <BabyRoomInfo data={companyDetails} />
          </>
        )}
        <ShowMore
          clicked={showMore}
          handleClick={showMore ? handleShowLess : handleShowMore}
        />
      </VStack>
      <VStack w="100%" maxW="1020px">
        <HStack justifyContent="flex-start" w="100%" spacing="30px" wrap="wrap">
          <Box width="250px">
            <ActionButton
              text={texts.management_reports.toUpperCase()}
              icon={faFileLines}
              onCLick={goToManagementReports}
            />
          </Box>
        </HStack>
      </VStack>
    </VStack>
  )
}
